import React , {Component} from 'react'
import {Link} from 'react-router-dom'
import {Container} from 'reactstrap'
import Card from './Card'
import $ from 'jquery';
import axios from 'axios';
import './Product.css'
import * as actionCreators from '../../Actions/Index';
import {withRouter} from 'react-router-dom';
import {connect} from "react-redux";
// import LoadingBar from "react-top-loading-bar";
import Cookies from 'universal-cookie';
import { Helmet } from 'react-helmet'
import TopNav from '../NavBar/TopNav'
const cookies = new Cookies();


window.$ = $;

class Product extends Component{
    constructor(props){
        super(props);
        this.state = {
            loadingBarProgress: 0,
            loaded: true,
            onload: true,
            products: [
               {id:6,title : 'Limelight', image: "http://cdn.shopify.com/s/files/1/2635/3244/products/U0387-SSH-PNK_1.jpg?v=1551876015", price: "1290",saveCount: 82},
            ],
            product:[],
            Title: "",
            Brand_Name:"",
            image:"",
            Price:0
           }
    }
    add = value => {
        this.setState({
          loadingBarProgress: this.state.loadingBarProgress + value
        });
      };
    
      complete = (tit,Brand_Name,image,Price) => {
        this.setState({ loadingBarProgress: 100 });
        this.setState({Title:tit,Brand_Name:Brand_Name,image:image,Price:Price});
      };
    
      onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
      };
    componentWillMount(){

             var id = this.props.match.params.id;
             id = id.split('=')[1];

        //   var  cat = {
        //       "ProductID": id,
        //       "UserID": cookies.get("usfid")
        //     }
      
             return axios.get(`https://selectfashion.herokuapp.com/getProductById/${id}`,
             { headers: {Origin:"http://localhost:3000",Host: "http://localhost:55414"} }).then((response)=>{
                 let res = JSON.parse(JSON.stringify(response));
             
                 if (res.statusText === "OK") {
                  this.setState({product:[res.data]});
                  this.setState({isloder:false});
                 } else {
                  console.log("something went wrong");
                 }
             })

        // var morph_api_url = `https://selectfashion.herokuapp.com/getProductById/${id}`;
        // var morph_api_params = {
        //   // Keep this key secret!
        //   key: '7hDDGSosf23K7474Bd4P',
        //   query: `Select product.productURL, product.ProductCount,product.saleper ,product.ProductID ,product.Price, product.Brand_Name,product.title,product.SKU from product where product.ProductID = ${id}`
        // };
      
        // let _this = this;
        // $.ajax({
        //   url: morph_api_url,
        //   dataType: 'jsonp',
        //   success: function(data){
        //       let res = JSON.parse(JSON.stringify(data));
        //       _this.setState({product:res.data});
        //       _this.setState({isloder:false});
        //   }
        // });


        // this.unlisten = this.props.history.listen((location, action) => {
        //     this.props.getSingleProduct(this.props.match.params.id);
        // this.setState({product:this.props.product});
        // });
        // this.props.getSingleProduct(this.props.match.params.id);
        // this.setState({product:this.props.product});
      
      }
      componentWillReceiveProps(nextProps){
        // this.setState({product:nextProps.product});
    }
    render(){
        if(this.state.onload == true){
             this.add(30);
             this.setState({onload:false});
        }
        return(
            <div>
                  <TopNav heading="Selectfashion"/> 
                   {/* <LoadingBar
          progress={this.state.loadingBarProgress}
          height={3}
          color="red"
          onLoaderFinished={() => this.onLoaderFinished()}
        /> */}
        <Helmet>
      <meta name="description" content= {`${this.state.Brand_Name} best collection available on SelectFashion.You can also compare ${this.state.Brand_Name} dresses with other Pakistani top brands dresses"`} />
      <title>{this.state.Title + " | " + this.state.Brand_Name}</title>
      <meta property="product:price:amount" content={this.state.Price}></meta>
      <meta property="og:image" content={this.state.image}></meta>
    </Helmet>
            <Container className="productContainer InnproductContainer text-center">  
            <ol className="product-items">
                
            {this.state.product.map(item=>{
                if(this.state.loaded == true){
                    this.complete(item.data.title,"Khaadi",item.data.URL,item.data.price);
                    this.setState({loaded:false});
               }
                    return(
            <Card  SKU={item.SKU} flag={item.flag == "true"? 1 : 0} 
            id={item.data._id} productURL={item.data.URL}
             ProductID={item.data._id} brand={item.Brand_Name} 
             title={item.data.mTitle} image={item.data.mImage} price={item.data.price} 
             saveCount={item.ProductCount}></Card>
            )}
            )}    
             </ol>
             </Container>  
            </div>
        )
    }
}
const mapStateToProps=(state)=>(

    {
    product:state.product,
  });
  
  const mapDispatchToProps = dispatch => {
    
    return {
        // getSingleProduct: (id) => dispatch(actionCreators.getSingleProduct(id)),
    }
    
  }
export default  withRouter(connect(mapStateToProps,mapDispatchToProps)(Product))
